import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';

var UIManager = function () {
  function UIManager(options) {
    _classCallCheck(this, UIManager);

    this.vm = options.vm;
    this.insertNodes = null;
    this.vertical = options.vertical;
    this.options = options;
  }

  _createClass(UIManager, [{
    key: 'buildRect',
    value: function buildRect(index) {
      return getChild(this.container, index).getBoundingClientRect();
    }
  }, {
    key: 'getMargin',
    value: function getMargin(index) {
      var style = window.getComputedStyle(getChild(this.container, index));
      return this.vertical ? parseInt(style.marginTop) + parseInt(style.marginBottom) : parseInt(style.marginLeft) + parseInt(style.marginRight);
    }
  }, {
    key: 'updateTranslateY',
    value: function updateTranslateY(_ref) {
      var _this = this;

      var e = _ref.e,
          moveRects = _ref.moveRects,
          ulRect = _ref.ulRect,
          sortStartC = _ref.sortStartC,
          areaDistance = _ref.areaDistance;
      var insertNodes = this.insertNodes,
          vertical = this.vertical,
          container = this.container;


      if (!insertNodes) {
        return;
      }
      var moveDistance = vertical ? e.clientY - sortStartC + container.scrollTop : e.clientX - sortStartC + container.scrollLeft;
      var key = vertical ? 'top' : 'left';
      insertNodes.forEach(function (node, index) {
        var offset = moveRects[index][key] - ulRect[key];
        node.style[key] = Math.min(Math.max(offset + moveDistance, vertical ? container.scrollTop : container.scrollLeft), vertical ? container.offsetHeight + container.scrollTop - areaDistance - _this.getMargin(index) : container.offsetWidth + container.scrollLeft - areaDistance - _this.getMargin(index)) + 'px';
      });
    }
  }, {
    key: 'doCloneNodes',
    value: function doCloneNodes(target, moveIndexs) {
      var _options$multiDragTex = this.options.multiDragTextGenerator,
          multiDragTextGenerator = _options$multiDragTex === undefined ? function () {
        return '';
      } : _options$multiDragTex;

      var nodes = this.insertNodes = [];
      var targetStyle = window.getComputedStyle(target);
      var node = target.cloneNode();
      node.innerHTML = target.innerHTML;
      node.style.position = 'absolute';
      node.style.zIndex = 100;
      node.className += ' is-drag';
      node.style.width = targetStyle.width;
      node.style.height = targetStyle.height;
      // debugger
      var length = moveIndexs.length;
      if (length > 1) {
        node.className += ' is-drag-more';
        var numberContainer = document.createElement('div');
        numberContainer.className += ' td-draglist-item__number';
        numberContainer.innerHTML = '<span>' + multiDragTextGenerator(moveIndexs) + '</span>';
        node.appendChild(numberContainer);
      }
      console.log(moveIndexs);
      nodes.push(node);
    }
  }, {
    key: 'doInsertNodes',
    value: function doInsertNodes() {
      var insertNodes = this.insertNodes,
          container = this.container;

      insertNodes && insertNodes.forEach(function (node) {
        return container.appendChild(node);
      });
    }
  }, {
    key: 'doRemoveNodes',
    value: function doRemoveNodes(el) {
      var insertNodes = this.insertNodes,
          container = this.container;

      if (insertNodes && container) {
        insertNodes.forEach(function (node) {
          if (container.contains(node)) {
            container.removeChild(node);
          }
        });
        this.insertNodes = null;
      }
    }
  }, {
    key: 'container',
    get: function get() {
      return this.options.container.call(this.vm);
    }
  }]);

  return UIManager;
}();


function getChild(elm, index) {
  return elm.children[index];
}

export default UIManager;
export { getChild };
